"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// zIndex range 1000 - 1999
var baseIndexes = {
  low: 1000,
  middle: 1500,
  high: 1900
};

var _default = _objectSpread(_objectSpread({}, baseIndexes), {}, {
  modal: baseIndexes.middle + 100,
  datepicker: baseIndexes.middle + 150,
  dropdownMenu: baseIndexes.middle + 200,
  popup: baseIndexes.middle + 250,
  tooltip: baseIndexes.middle + 300,
  snackbar: baseIndexes.high,
  critical: baseIndexes.high + 99
});

exports["default"] = _default;